// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3w_Mv","buttons":"PendingPaymentAlert_buttons__cv3vr"};